const e = "_overlay_1azxr_1", a = "_window_1azxr_14", s = "_modalSlideUp_1azxr_1", _ = "_header_1azxr_47", o = "_close_1azxr_61", r = "_messages_1azxr_75", t = "_message_1azxr_75", m = {
  overlay: e,
  window: a,
  modalSlideUp: s,
  header: _,
  close: o,
  messages: r,
  "messages--date": "_messages--date_1azxr_84",
  message: t,
  "message--avatar": "_message--avatar_1azxr_97",
  "message--details": "_message--details_1azxr_133",
  "message--author": "_message--author_1azxr_141",
  "message--text": "_message--text_1azxr_144",
  "message--time": "_message--time_1azxr_149",
  "loading-container": "_loading-container_1azxr_175"
};
export {
  o as close,
  m as default,
  _ as header,
  t as message,
  r as messages,
  s as modalSlideUp,
  e as overlay,
  a as window
};
